import type { IVehicle } from "@domain/Vehicle";
import type { ISmsMessage, ISmsMessageDto } from "./ISmsMessage";

export class SmsMessage implements ISmsMessage
{
    message: string;
    utcDateCreated: string;
    isConsumer: boolean;
    vehicleId?: string;
    name: string;
    vehicle?: IVehicle;

    constructor( model: ISmsMessageDto, vehicle?: IVehicle )
    {
        this.message = model.message;
        this.utcDateCreated = model.utcDateCreated;
        this.isConsumer = model.isConsumer;
        this.vehicleId = model.vehicleId;
        this.name = model.name;
        this.vehicle = vehicle;
    }

}
